export default "__VITE_ASSET__bf6fd80c__"